/* eslint-disable max-len */
import PropTypes from "prop-types";
import { searchToObject } from '../../../utils/index'

import * as React from "react";
import dwhExport from '~/dwhExport'
import { sendEventToGTM } from "helpers/analytics";
import { translate, Interpolate } from "react-i18next";
import { ClanResource, Button, ButtonGroup, DialogContainer, DialogHeader, DialogBody, DialogFooter, Divider, HelperIcon, Message } from "@wg/wows-react-uikit";

import { x } from "helpers/localization";
import settings from "settings";

import styles from "./SendApplicationDialog.scss";

const SOURCE_MAP = {
  clan_recommendations: 'Recommendations page',
  profile: 'Profile page',
  clan_profile: 'Clan profile page',
  clan_search: 'Search page',
  player_search: 'Player search page'
};

export interface SendApplicationDialogProps {
  clanLeveling: number,
  clanId: number,
  source: string,
  isFetchingJoinClan: boolean,
  isHiddenAccount: boolean,

  onClick: () => void,
  onHideDialog: () => void,
  t: (str: string) => string
}

class SendApplicationDialog extends React.PureComponent<SendApplicationDialogProps> {

  onClick = () => {
    const query = searchToObject()
    if (query.source && query.purpose) {
        dwhExport.send(`${query.source}.${query.purpose}.open_clan.send_request`)
    }
    sendEventToGTM({
      category: SOURCE_MAP[this.props.source],
      action: 'Click: Send application join clan dialog',
      label: 'Button send application in join clan dialog',
      clanId: this.props.clanId
    });

    this.props.onClick();
  }

  onHideDialog = () => {
    sendEventToGTM({
      category: SOURCE_MAP[this.props.source],
      action: 'Click: Hide join clan dialog',
      label: 'Button close in join clan dialog',
      clanId: this.props.clanId
    });

    this.props.onHideDialog();
  }


  renderHiddenAccountConfirm() {
    const t = this.props.t;

    return this.props.isHiddenAccount ? <div className={styles.hiddenAccountMessage}>
      <Divider type="major" />
      <div className={styles.info}>
        <Message style={'inline'} type="confirmation">{t('Игроки клана, которые рассмотрят вашу заявку, получат доступ к вашей статистике по следующим показателям: количество боёв, процент побед, средний опыт, урон и количество уничтоженных кораблей за бой.')}</Message>
      </div>
    </div> : null;
  }

  render() {
    const t = this.props.t;
    const needResource = settings.supply.clanLevelingToAccountLeveling[this.props.clanLeveling];

    const clanLevelingContent = (
      <React.Fragment>
        <Divider type="major" />
        <div className={styles.info}>
          <Interpolate i18nKey={x('Чтобы пользоваться клановыми бонусами, необходимо заработать %(resource)s')} resource={<ClanResource amount={needResource} />} />
          <span className={styles.helperIcon}>
            <HelperIcon header={t('Допуск к клановым бонусам')}>
              <p>{t('Чтобы пользоваться клановыми бонусами, необходимо заработать определённое количество баррелей нефти.')}</p>
              <p>{t('Количество баррелей нефти, необходимое для получения допуска, зависит от уровня клана.')}</p>
              <p>{t('Чем сильнее клан, тем больше баррелей нефти необходимо заработать для получения допуска к бонусам.')}</p>
            </HelperIcon>
          </span>
        </div>
      </React.Fragment>
    )

    return <DialogContainer>
      <DialogHeader>{t('Вступление в клан')}</DialogHeader>
      <DialogBody>
        <div className={styles.confirmation + (needResource ? ' ' + styles['confirmation-complex'] : '')}>{t('Вы уверены, что хотите отправить заявку на вступление в клан?')}</div>
        {this.renderHiddenAccountConfirm()}
        {needResource ? clanLevelingContent : null}
      </DialogBody>
      <DialogFooter>
        <ButtonGroup isLoading={this.props.isFetchingJoinClan}>
          <div data-staff-name={this.props.source === 'clan_recommendations' ? 'recommendations_join-popover_join' : 'join-popover_join'} data-staff-clan-id={this.props.clanId}>
            <Button isJustified isHighlighted onClick={this.onClick}>
              {t('Вступить в клан')}
            </Button>
          </div>
          <div data-staff-name={this.props.source === 'clan_recommendations' ? 'recommendations_join-popover_close' : 'join-popover_close'} data-staff-clan-id={this.props.clanId}>
            <Button isJustified onClick={this.onHideDialog}>
              {t('Отменить')}
            </Button>
          </div>
        </ButtonGroup>
      </DialogFooter>
    </DialogContainer>;
  }
}

export default translate()(SendApplicationDialog);